var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 24,
    viewBox: "0 0 28 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3 0H4.6C3.2 0 2 1.2 2 2.7V21.3C2 22.7 3.2 23.9 4.6 23.9H23.3C24.8 23.9 25.9 22.7 25.9 21.2V2.7C26 1.2 24.8 0 23.3 0ZM12.7 21.3H4.7V21.2V2.7H12.7V21.3ZM23.3 21.2H15.3V12H23.3V21.2ZM23.3 9.3H15.3V2.7H23.3V9.3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDashboard);
export default __webpack_public_path__ + "static/media/icon_dashboard.e3701d956b3d3258fc051ab676c7d25e.svg";
export { ForwardRef as ReactComponent };